import { hydrateRoot, createRoot, type Root } from "react-dom/client";
import type { OnRenderClientAsync } from "vike/types";
import { PageShell } from "./PageShell";

let root: Root | null = null;

// Kartenebenen ohne eigenen Schlüssel (Ort-Beat aus dem Beat-Editor) nehmen
// diesen; der Renderer liest ihn als Rückfall (RendererWebGL, MapTiler-Ebene).
// Läuft nur im Browser, nie beim SSR.
if (typeof window !== "undefined" && import.meta.env.VITE_MAPTILER_KEY) {
  (window as unknown as { __MAPTILER_API_KEY__?: string }).__MAPTILER_API_KEY__ =
    import.meta.env.VITE_MAPTILER_KEY;
}

const onRenderClient: OnRenderClientAsync = async (
  pageContext,
): ReturnType<OnRenderClientAsync> => {
  const { Page } = pageContext;
  if (!Page) throw new Error("No page component found.");

  const container = document.getElementById("root");
  if (!container) throw new Error("#root not found.");

  const tree = (
    <PageShell pageContext={pageContext}>
      <Page />
    </PageShell>
  );

  if (pageContext.isHydration) {
    root = hydrateRoot(container, tree);
  } else {
    if (!root) root = createRoot(container);
    root.render(tree);
  }
};

export default onRenderClient;
